module.exports = __webpack_public_path__ + "static/media/values-empty-state.443709d9.svg";